import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";

import { SubHeading, WelcomeBackHeading } from "../../components";

export const ExistingUser = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <WelcomeBackHeading />
        <SubHeading>
            <FormattedMessage
                id="signup.teamworkCollection.subHeading"
                defaultMessage="It’s free for up to 10 users - no credit card needed."
            />
        </SubHeading>
        <SiteActivation />
    </SignupBackgroundLayout>
);
